/**
 * Critical JavaScript - Loads first on every page
 * Initializes cart state and scroll animations
 */

import { updateCartBubble } from './utilities.js';
import { initScrollAnimations } from './scroll-animations.js';

initScrollAnimations();

document.addEventListener('DOMContentLoaded', () => {
  updateCartBubble();
});

// Sitewide details script to ensure no overlap with other same page details containers



